module.exports = __webpack_public_path__ + "static/home_progress@2x-81bbed90399ebcffd55d80ee3e8f85a6.png";